import { motion } from "framer-motion";
import StatCounter from "@/components/StatCounter";

const STATS = [
  { value: 99, suffix: "%+", label: "Verified Purity" },
  { value: 100, suffix: "%", label: "Third-Party Tested — Every Batch" },
  { value: 24, suffix: " Hrs", label: "Average Processing Time" },
  { value: 500, suffix: "+", label: "Research Clients Served" },
];

export default function StatsSection() {
  return (
    <section className="relative py-20 bg-white overflow-hidden" data-testid="stats-section">
      <div className="absolute inset-0 bg-radial-blue-glow opacity-70 pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-6 md:px-12 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {STATS.map((s, idx) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            className="text-center"
            data-testid={`stat-item-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <p className="font-display font-bold text-4xl sm:text-5xl text-gradient-blue">
              <StatCounter value={s.value} suffix={s.suffix} />
            </p>
            <p className="mt-2 text-xs uppercase tracking-wider text-slate-500 font-medium">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
